// ================================================= /
// ======   HUBSPOT JS  ============================ /
// ================================================= /

/* global jQuery */

import form from '../form';

/**
 * Class for handling HubSpot Forms plugin extensions.
 */
class DispatchSkinHubSpot {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.formSelector = '.hbspt-form';
		this.fieldSelector = '.hs-form-field';

		this.eventNamespace = 'dispatchSkinHubSpotForms';
		this.focusClass = 'has-focus';
		this.focusedFieldsClass = 'has-focused-fields';
		this.floatingLabelClass = 'has-floating-label';
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		if ( jQuery( this.formSelector ).length ) {

			this.eventDelegationParent = jQuery( '.site' );

			// Input focus
			this.eventDelegationParent.on(
				`focus.${this.eventNamespace}`,
				this.formSelector + ' :input:not([type="submit"])',
				( event ) => form.focusInput( jQuery( event.target ), this.formSelector, this.fieldSelector )
			);
			this.eventDelegationParent.on(
				`focusout.${this.eventNamespace}`,
				this.formSelector + ' :input',
				() => form.blurInput( jQuery( event.target ), this.formSelector, this.fieldSelector )
			);
			this.eventDelegationParent.on(
				`change.${this.eventNamespace}`,
				this.formSelector + ' select',
				() => form.blurInput( jQuery( event.target ), this.formSelector, this.fieldSelector )
			);

			window.addEventListener(
				'message',
				function( event ) {
					if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady' ) {
						this.checkAllInputs();
					}
				}.bind( this )
			);

			this.checkAllInputs();
		}
	}

	/**
	 * Blurs all the inputs.
	 */
	checkAllInputs() {

		jQuery( this.formSelector + ' :input' ).each(

			function( index, input ) {

				input = jQuery( input );

				const field = input.closest( this.fieldSelector );

				if ( input.val() ) {

					field.addClass( form.floatingLabelClass );
				}
			}.bind( this )
		);
	}

}

const hubSpot = new DispatchSkinHubSpot();
export default hubSpot;



// WEBPACK FOOTER //
// ./src/js/inc/plugins/hubspot.js